module.exports = __webpack_public_path__ + "img/2.777dbe90.png";